import { Trans } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import type { QuestionTreeItem } from '/business/shared/functions/types';

import useUrlBuilder from '/business/shared/hooks/useUrlBuilder';
import getApplicationIdSelector from '/business/shared/state/selectors/application/getApplicationIdSelector';

import OverviewSidebarTip from '/shared/components/widgets/overview/OverviewSidebarTip';
import StyledParagraph from '/shared/styled/components/StyledParagraph';

const ACTIVITY_DATA_ID = 'activity-data';

function EmployeeCommutesWorkforceInfoTip({ question }: { question: QuestionTreeItem }) {
  const { getUrlWithAppId } = useUrlBuilder();
  const applicationId = useSelector(getApplicationIdSelector);

  const path = Array.isArray(question.path) ? question.path : [];
  const basePath = path.slice(0, path.indexOf(ACTIVITY_DATA_ID)).join('/');

  return (
    <OverviewSidebarTip>
      <StyledParagraph $smallText as="div">
        <Trans
          i18nKey="business:QuestionPage.forms.commutesActivityData.infoBody"
          components={{ 1: <Link to={getUrlWithAppId(`${basePath}/workforce-breakdown`, applicationId)} /> }}
        />
      </StyledParagraph>
    </OverviewSidebarTip>
  );
}

export default EmployeeCommutesWorkforceInfoTip;
